import * as React from 'react'
import { HomePageHero } from 'components/Hero/HomePageHero'
import { AppBanner } from 'components/Banner/AppBanner'
import { SectionWithTitle } from 'components/SectionWithTitle/SectionWithTitle'
import { BrandCarousel } from 'components/BrandCarousel/BrandCarousel'
import { DeliveryLocations } from 'components/DeliveryLocations/DeliveryLocations'
import { CategoriesSection } from 'components/CategoriesSection/CategoriesSection'
import { SectionValuesList } from 'components/SectionValuesList/SectionValuesList'
import { PromoDisclaimerSection } from 'components/PromoDisclaimerSection/PromoDisclaimerSection'
import { SEO } from 'components/SEO/SEO'
import { BlogPost } from 'components/BlogPost/BlogPost'
import {
  mapContentfulStoreIconsToColorsSet,
  mapContentfulValues,
  mapContentfulCategoriesToCategoriesTileData,
  mapContentfulBrandLogos,
  mapContentfulLocations,
} from 'utils/helpers'
import { ContentfulMainQuery } from '../../graphql/generated-types'
import { SharedPageContext } from './types'

interface HomePageTemplateProps {
  pageContext: SharedPageContext & {
    categoriesData: ContentfulMainQuery['categoriesData']['categoriesSection']['data']
  }
}

const HomePageTemplate = ({
  pageContext: { sharedPageData, prefixes, categoriesData, locationsData },
}: HomePageTemplateProps) => {
  const {
    homePageHeroCopy,
    heroCarouselImages,
    asSeenInSection,
    appBannerSection,
    blogPost,
    categoriesSection,
    storesIcons,
    locations,
    valuesListSection,
    homePageSeo,
    isPromoActive,
    promotion,
  } = sharedPageData

  const { categoryPrefix, locationPrefix } = prefixes

  const storesIconsMapped = mapContentfulStoreIconsToColorsSet(storesIcons)

  return (
    <>
      <SEO
        title={homePageSeo.title}
        description={homePageSeo.description.description}
      />
      <HomePageHero title={homePageHeroCopy} images={heroCarouselImages} />
      <main>
        <SectionValuesList
          values={mapContentfulValues(valuesListSection.values)}
        />
        <CategoriesSection
          pathnamePrefix={categoryPrefix}
          categories={mapContentfulCategoriesToCategoriesTileData(
            categoriesData
          )}
          title={categoriesSection.title}
        />
        {asSeenInSection && (
          <SectionWithTitle title={asSeenInSection.title}>
            <BrandCarousel
              icons={mapContentfulBrandLogos(asSeenInSection.brandLogos)}
            />
          </SectionWithTitle>
        )}
        {blogPost && (
          <BlogPost
            title={blogPost.title}
            description={blogPost.description.description}
            img={blogPost.image}
            url={blogPost.url}
          />
        )}

        {locations && (
          <DeliveryLocations
            title={locations.title}
            locations={mapContentfulLocations(locationsData)}
            pathnamePrefix={locationPrefix}
          />
        )}

        {isPromoActive && promotion ? (
          <PromoDisclaimerSection text={promotion.disclaimer} />
        ) : null}
        <AppBanner
          image={appBannerSection.image}
          storesIcons={storesIconsMapped.black}
          text={appBannerSection.desktop}
          mobileText={appBannerSection.mobile}
        />
      </main>
    </>
  )
}

export default HomePageTemplate
